import { INVOICE_STATUSES } from '../../consts/consts';
import { formatDate, isUnsentOverdueInvoice } from '../../utils';

export const getDueDateNoticeTextStyle = (status: string) => {
  if (status === INVOICE_STATUSES.OUTSTANDING || status === INVOICE_STATUSES.PAYMENT_DECLINED) return 'text-sm text-red02';
  if (status === INVOICE_STATUSES.PAYMENT_PENDING) return 'text-sm text-action05';
  if (status === INVOICE_STATUSES.PAID) return 'text-sm text-badgeGreen02';
  return '';
};
export const getDueDateNoticeText = (status: string, numOfOverdueDays: number, t: any, paidTime?: string) => {
  if (isUnsentOverdueInvoice(status, numOfOverdueDays)) {
    const resource = numOfOverdueDays > 1 ? 'INVOICES_TABLE.COLUMNS.DUEDATE.DAYS_OVERDUE' : 'INVOICES_TABLE.COLUMNS.DUEDATE.DAY_OVERDUE';
    return `${numOfOverdueDays} ${t(resource)}`;
  }
  if (status === INVOICE_STATUSES.PAYMENT_PENDING) return `${t('INVOICES_TABLE.COLUMNS.DUEDATE.PAYMENT_PENDING')}`;
  if (status === INVOICE_STATUSES.PAYMENT_DECLINED) return `${t('INVOICES_TABLE.COLUMNS.DUEDATE.PAYMENT_DECLINED')}`;
  if (status === INVOICE_STATUSES.PAID) return formatDate(paidTime, false);
  return '';
};
